export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY ="002c0d91-6194-40ee-ab9f-eb0f33d15943";


export const MODAL_CLOSE_SEC =2.5;